import type { LucideIcon } from 'lucide-react';

export function EmptyState({
  icon: Icon,
  title,
  description,
  action,
}: {
  icon?: LucideIcon;
  title: string;
  description?: string;
  action?: React.ReactNode;
}) {
  return (
    <div className="flex flex-col items-center justify-center gap-3 rounded-xl border border-dashed border-slate-300 bg-white p-10 text-center">
      {Icon && <Icon className="h-8 w-8 text-slate-400" aria-hidden="true" />}
      <div className="text-sm font-medium text-slate-700">{title}</div>
      {description && <div className="max-w-md text-xs text-slate-500">{description}</div>}
      {action}
    </div>
  );
}
